<template>
  <div>
    <br>
    <br>
    <div class="section py-0 px-5" v-if="afficherSlider">
      <vue-slider :min="rayonMin"
                  :max="rayonMax"
                  :interval="rayonInterval"
                  :clickable= false
                  v-model="rayon"
                  tooltip="always"
                  formatter="{value} km"
                  @drag-end="dragEnd"/>
    </div>
    <hr>
    <app-date/>
    <hr>
    <app-disponibilite/>
    <hr v-if="!isAffixe2">
    <app-proposable-lc v-if="!isAffixe2"/>
    <hr>
    <app-ajout-filtre/>
    <app-affectation/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import vueSlider from 'vue-slider-component';
import gestionErreur from '@/services/general/gestionErreur';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import { RAYON_MAX, RAYON_MIN, RAYON_INTERVAL } from '@/configuration/carteConf';
import filtreDate from './date';
import filtreDisponibilite from './disponibilite';
import AjoutFiltre from './ajoutFiltre';
import filtreAutocomplete from './autocomplete';
import filtreProposableLc from './proposableLc';
import filtreAffectation from './affectation';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');
const Parametrage = createNamespacedHelpers('parametrage');

export default {
  name: 'filtresPatrimoine',
  props: ['afficherSlider'],
  components: {
    vueSlider,
    appDate: filtreDate,
    appDisponibilite: filtreDisponibilite,
    appAjoutFiltre: AjoutFiltre,
    appAutocomplete: filtreAutocomplete,
    appProposableLc: filtreProposableLc,
    appAffectation: filtreAffectation,
  },
  data() {
    return {
      rayonMax: RAYON_MAX,
      rayonMin: RAYON_MIN,
      rayonInterval: RAYON_INTERVAL,
      valid: false,
    };
  },
  computed: {
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    ...VenteFacesLc.mapGetters({
      address: 'address',
      getRayon: 'rayon',
    }),
    ...Parametrage.mapGetters({
      isAffixe2: 'affixe2',
    }),
    rayon: {
      get() {
        return this.getRayon;
      },
      set(value) {
        this.setFilterRayon(value);
      },
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setFilterRayon: types.SET_FILTER_RAYON,
      setAffichageCercle: types.SET_AFFICHAGE_CERCLE,
    }),
    ...VenteFacesLc.mapActions({
      actionsGestionPanneauxLc: 'gestionPanneauxLC',
    }),
    dragEnd() {
      if (this.address) {
        this.valid = true;
        this.setAffichageCercle(true);
        this.recherchePanneauxLc();
      }
    },
    recherchePanneauxLc() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsGestionPanneauxLc({ address: this.address,
        codeFace: '',
        rayon: this.rayon,
        valid: this.valid,
        panneauxLcPanier: this.panneauxLcPanier,
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche d\'un panneaux LC liée aux filtres patrimoines', e);
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/filtresPatrimoine.vue